<template>
    <div class="ls-customer-details--container">
        <h2 class="ls-customer-details--name">
            <LsBrand :brand="customer.brand" :show-name="false" size="lg" />
            <span class="ls-customer-details--name-text">
                {{ customer.user | fullName }}
                <span
                    v-if="customer.is_customer_lead"
                    class="ls-customer-details--name-customer-lead"
                >
                    (Customer lead)
                </span>
            </span>
        </h2>
        <div class="ls-customer-details--info">
            <div>
                <img :src="require('./assets/mail.svg')" />
                <span>{{ customer.user.email }} {{ `(${verified})` }}</span>
            </div>
            <div>
                <img :src="require('./assets/phone.svg')" />
                <span> {{ customer.user.phone | formattedPhone }}</span>
            </div>
            <div>
                <img :src="require('./assets/balance.svg')" />
                <span :class="{ negative: negativeBalance }">{{ customer.balance }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import LsBrand from '@/components/LsBrand/LsBrand.vue';

export default {
    name: 'LsCustomerDetails',
    components: {
        LsBrand,
    },
    props: {
        customer: VueTypes.shape({
            balance: VueTypes.number.isRequired,
            user: VueTypes.shape({
                first_name: VueTypes.string.isRequired,
                last_name: VueTypes.string.isRequired,
                email: VueTypes.string.isRequired,
                phone: VueTypes.string.isRequired,
                email_verified: VueTypes.bool.isRequired,
            }).isRequired.loose,
            brand: VueTypes.string.isRequired,
        }).isRequired.loose,
    },
    computed: {
        verified() {
            const { user } = this.customer;

            return user.email_verified ? 'verified' : 'unverified';
        },
        negativeBalance() {
            return this.customer.balance < 0;
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-customer-details--container {
    display: flex;
    flex-direction: column;
}

.ls-customer-details--name {
    display: flex;
    align-items: center;
    color: $secondary-dark;
    font-size: $size-2;
    font-weight: $semi-bold;

    .ls-customer-details--name-text {
        margin-left: 8px;
        font-size: inherit;
    }

    .ls-customer-details--name-customer-lead {
        font-size: 0.8em;
        font-weight: normal;
    }
}

.ls-customer-details--info {
    color: $secondary;
    display: flex;
    // compensate for extra space around svg
    margin: 10px 0 0 -5px;
    > div {
        height: 18px;
        display: flex;
        align-items: center;
        border-right: 1px solid $gray-primary;
        padding: 0 15px;

        &:first-child {
            padding-left: 0;
        }

        &:last-child {
            border: none;
        }
    }

    .negative {
        color: $danger;
    }
}
</style>
